module.exports = "<option value=\"{%- targetKey %}\">{%- text %}</option>";


//////////////////
// WEBPACK FOOTER
// ./src/sharedHtml/linkGroup/optionTemplate.html
// module id = 135
// module chunks = 1